import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, CircularProgress, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const libraries = ['places'];

const GymMapModal = ({ open, onClose, gym }) => {
  const [coordinates, setCoordinates] = useState(null);
  const [loading, setLoading] = useState(true);

  const mapContainerStyle = {
    width: '100%',
    height: '400px'
  };

  // Default center (Barcelona) in case coordinates are not available
  const defaultCenter = {
    lat: 41.3851,
    lng: 2.1734
  };

  // Function to get coordinates from address using Google Geocoding API
  const getCoordinates = async (address, geocoder) => {
    try {
      const result = await geocoder.geocode({ address });
      if (result.results[0]) {
        return result.results[0].geometry.location;
      }
      return defaultCenter;
    } catch (error) {
      console.error('Error geocoding address:', error);
      return defaultCenter;
    }
  };

  const onLoad = async (map) => {
    if (!gym?.address) {
      setCoordinates(defaultCenter);
      setLoading(false);
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    const fullAddress = `${gym.address}${gym.city ? `, ${gym.city}` : ''}${gym.postal_code ? ` ${gym.postal_code}` : ''}`;
    const coords = await getCoordinates(fullAddress, geocoder);
    setCoordinates(coords);
    setLoading(false);
  };

  // Reset states when modal closes or gym changes
  useEffect(() => {
    if (!open || !gym) {
      setCoordinates(null);
      setLoading(true);
    }
  }, [open, gym]);

  const handleClose = () => {
    setCoordinates(null);
    setLoading(true);
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {gym?.name}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={coordinates || defaultCenter}
          zoom={15}
          onLoad={onLoad}
        >
          {!loading && coordinates && (
            <Marker
              position={coordinates}
              icon={{
                url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
              }}
            />
          )}
        </GoogleMap>
      </DialogContent>
    </Dialog>
  );
};

// Wrap the modal with LoadScript to ensure it's only loaded once
const GymMapModalWithScript = (props) => (
  <LoadScript
    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
    libraries={libraries}
  >
    <GymMapModal {...props} />
  </LoadScript>
);

export default GymMapModalWithScript; 